export default __webpack_public_path__ + "static/media/691.b74127fe.png";